<script setup lang="ts">
// L'image est rendue via le slot `picture` (composant responsive `picture/srcset` côté web,
// simple `img` en fallback mobile).
interface CtaArticle {
  title: string;
  content?: string | null;
  mainImage?: { url?: string | null } | null;
}

defineProps<{ article: CtaArticle | null }>();

const stores = [
  {
    platform: "ios",
    label: "App Store",
    image: "/images/welcome/app-store-badge.png",
    url: "https://apps.apple.com/fr/app/carnet-de-plongee/id1234567890",
  },
  {
    platform: "android",
    label: "Google Play",
    image: "/images/welcome/google-play-badge.png",
    url: "https://play.google.com/store/apps/details?id=fr.ffessm.moncarnetdeplongee",
  },
] as const;
</script>

<template>
  <AppSection v-if="article" :ui="{ base: 'py-16 md:py-10' }">
    <div class="grid md:grid-cols-2 gap-4 md:gap-8 items-center">
      <div class="max-md:row-2 relative md:aspect-square overflow-hidden">
        <slot name="picture" :article="article">
          <AppImage v-if="article.mainImage?.url" :src="article.mainImage.url" :alt="article.title" />
        </slot>
      </div>
      <div class="lg:ml-10">
        <div class="mb-6 lg:mb-10">
          <h2 class="text-2xl sm:text-3xl md:text-4xl font-semibold not-last:mb-2">
            {{ article.title }}
          </h2>
          <p v-if="article.content" class="text-base/snug md:text-xl/[1.4]">
            {{ article.content }}
          </p>
        </div>
        <ul class="flex gap-2 flex-wrap">
          <li v-for="store in stores" :key="store.platform">
            <ULink :href="store.url" target="_blank" rel="noopener noreferrer" class="inline-block hover:opacity-92 rounded-lg">
              <img :src="store.image" :alt="store.label" class="h-10 w-auto" />
            </ULink>
          </li>
        </ul>
      </div>
    </div>
  </AppSection>
</template>
